import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import {push} from "connected-react-router";

class Communicate extends React.Component<CommunicateProps, {}> {

    componentDidMount = () => {
        if(this.props.token !== undefined && this.props.tokenType !== undefined) {
            axios.defaults.headers.authorization = this.props.tokenType + " " + this.props.token;
        }
    };

    componentDidUpdate(prevProps: Readonly<CommunicateProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if(this.props.token !== undefined && this.props.tokenType !== undefined) {
            axios.defaults.headers.authorization = this.props.tokenType + " " + this.props.token;
        }
        if(prevProps.token !== undefined && this.props.token === undefined && this.props.tokenType === undefined) {
            this.props.redirectToPage("/sign-out");
        }
    }

    render() {
        return false;
    }
}

interface CommunicateProps {
    token?: string;
    tokenType?: string;
    redirectToPage(value: string): void;
}

const mapStateToProps = (state: any) => ({
    token: state.oidc.user != null ? state.oidc.user.access_token : undefined,
    tokenType: state.oidc.user != null ? state.oidc.user.token_type : undefined
});

const mapDispatchToProps = (dispatch: Function) => ({

    redirectToPage: (value: string) => {
        dispatch(push(value));
    },
});


export default connect(mapStateToProps, mapDispatchToProps)(Communicate);
